var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';

function SvgAlertSuccess(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "#FFF",
    d: "M27.68 14.765c0-.736.616-1.333 1.375-1.333.76 0 1.375.597 1.375 1.333v1.24c-.004 6.496-4.413 12.216-10.836 14.057-6.424 1.842-13.332-.633-16.977-6.082-3.646-5.449-3.162-12.574 1.19-17.512C8.16 1.531 15.342-.043 21.461 2.6c.694.3 1.005 1.088.696 1.761-.309.673-1.122.975-1.815.675-5.006-2.163-10.883-.875-14.444 3.165-3.56 4.04-3.957 9.87-.974 14.328 2.983 4.458 8.634 6.483 13.89 4.976 5.255-1.507 8.863-6.186 8.866-11.5v-1.24zm-12.375 2.021L29.458 3.062a1.406 1.406 0 011.944 0c.537.52.537 1.365 0 1.886L16.277 19.615c-.537.52-1.407.52-1.944 0l-4.125-4a1.305 1.305 0 010-1.886 1.406 1.406 0 011.944 0l3.153 3.057z"
  }));
}

export default SvgAlertSuccess;